import { Dispatch } from "redux";
import {
  ERROR_LOADING_UNREAD_NOTIFICATIONS,
  GET_UNREAD_NOTIFICATIONS_STATUS,
  RESET_UNREAD_NOTIFICATIONS,
  START_LOADING_UNREAD_NOTIFICATIONS,
  STOP_LOADING_UNREAD_NOTIFICATIONS,
} from "./action-types";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import { IFetchUnreadNotifications } from "./initialState";

export const fetchUnreadNotificationsStatusAction =
  (calledViaInterval: boolean = false) =>
  async (dispatch: Dispatch) => {
    if (!calledViaInterval) {
      dispatch({ type: START_LOADING_UNREAD_NOTIFICATIONS });
    }

    try {
      const response =
        await apiLibrary.NotificationCenter.hasUnreadNotifications();
      dispatch({
        type: GET_UNREAD_NOTIFICATIONS_STATUS,
        payload: {
          data: response.data,
        },
        message: response.message,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      //   Toasts.error(errorMsg);
      console.log(
        "An error occurred while fetching unread notifications status:",
        error
      );
      dispatch({
        type: RESET_UNREAD_NOTIFICATIONS,
      });
      console.log(
        "An error occurred while fetching unread notifications status:",
        error
      );
      dispatch({ type: ERROR_LOADING_UNREAD_NOTIFICATIONS });
    } finally {
      if (!calledViaInterval) {
        dispatch({ type: STOP_LOADING_UNREAD_NOTIFICATIONS });
      }
    }
  };
